import { HttpHeaders } from '@angular/common/http';

/** Noms / valeurs d'en-têtes HTTP partagés (auth, JSON, retry). */
export const HTTP_HEADER_NAMES = {
  contentType: 'Content-Type',
  authorization: 'Authorization',
  retryAfterRefresh: 'X-Retry-After-Refresh',
  authRefreshRetry: 'X-Auth-Refresh-Retry',
} as const;

export const HTTP_HEADER_VALUES = {
  applicationJson: 'application/json',
} as const;

/** En-têtes JSON pour les corps {@code application/json} (hors {@code FormData}). */
export function jsonHttpHeaders(): HttpHeaders {
  return new HttpHeaders({
    [HTTP_HEADER_NAMES.contentType]: HTTP_HEADER_VALUES.applicationJson,
  });
}
